import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { ParentProfileChangesFilters, parentProfileChangesApi } from '@/services';

export const parentProfileChangesKeys = {
  all: ['admin', 'parent-profile-changes'] as const,
  list: (filters: ParentProfileChangesFilters = {}) => ['admin', 'parent-profile-changes', 'list', filters] as const,
  unreviewedCount: () => ['admin', 'parent-profile-changes', 'unreviewed-count'] as const,
};

export function useParentProfileChangesQuery(filters: ParentProfileChangesFilters = {}) {
  return useQuery({
    queryKey: parentProfileChangesKeys.list(filters),
    queryFn: () => parentProfileChangesApi.list(filters),
  });
}

export function useUnreviewedParentChangesCountQuery(enabled = true) {
  return useQuery({
    queryKey: parentProfileChangesKeys.unreviewedCount(),
    queryFn: () => parentProfileChangesApi.unreviewedCount(),
    enabled,
    select: r => r.count,
  });
}

// Both mutations invalidate the whole `all` branch (not just list/unreviewedCount) so the
// list and the sidebar badge move together off a single review click, on this page or any
// other that reads the count.
export function useReviewParentChangeMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => parentProfileChangesApi.review(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: parentProfileChangesKeys.all }),
  });
}

export function useReviewAllParentChangesMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => parentProfileChangesApi.reviewAll(),
    onSuccess: () => qc.invalidateQueries({ queryKey: parentProfileChangesKeys.all }),
  });
}
